import { render, staticRenderFns } from "./FreeBetsModal.vue?vue&type=template&id=8882ec78&scoped=true"
import script from "./FreeBetsModal.vue?vue&type=script&lang=js"
export * from "./FreeBetsModal.vue?vue&type=script&lang=js"
import style0 from "./FreeBetsModal.vue?vue&type=style&index=0&id=8882ec78&prod&scoped=true&lang=css"
import style1 from "./FreeBetsModal.vue?vue&type=style&index=1&id=8882ec78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8882ec78",
  null
  
)

export default component.exports